import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicUser, UpdateUserDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateUser = async ({
  userId,
  user,
}: {
  userId: string;
  user: UpdateUserDto;
}): Promise<PublicUser> => {
  const response = await axiosClient.patch(`users/${userId}`, user);
  return response.data;
};

function useUpdateUser(
  mutationOptions?: UseMutationOptions<
    PublicUser,
    HttpError,
    { userId: string; user: UpdateUserDto }
  >,
) {
  return useMutation({
    mutationFn: updateUser,
    ...mutationOptions,
  });
}

export { useUpdateUser };
